import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { UserDetails } from "../redux/userSlice";
import axios from "axios";
import LoaderModal from "../components/ModalLoader/LoaderModal";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";

const AdminSettings = () => {
  const [showModal, setShowModal] = useState(false);
  const APi_Url = process.env.REACT_APP_ENIGMA_API;
  const [accountModal, setaccountModal] = useState(false);

  const userDetails = useSelector(UserDetails);
  const token = userDetails?.token;
  //
  const [docusignControlId, setDocusignControlId] = useState();
  const [createAccountDisplayOnWebsite, setcreateAccountDisplayOnWebsite] =
    useState();
  const [adminAddUser, setadminAddUser] = useState();
  const [adminAddUserDocuSign,setAdminAddUserDocuSign]=useState();
  const [websiteCreateAccount, setwebsiteCreateAccount] = useState();
  const [zapurl, setzapurl] = useState();
 

  const [defaultPassword, setDefaultPassword] = useState([]);

  const getAllDocuSign = async () => {
    setShowModal(true);
    try {
      const response = await axios.get(
        `${APi_Url}api/account/get-all-docusign`,

        {
          headers: {
            Accept: "application/json",
            // "Content-Type": "application/json",
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        console.log(
          "resposne get all docusign list ",
          response?.data?.response[0]
        );
        setDocusignControlId(response?.data?.response[0].docuSignControlId);
        setcreateAccountDisplayOnWebsite(
          response?.data?.response[0].createAccountDisplayOnWebsite
        );
        setadminAddUser(response?.data?.response[0].adminAddUser);
        setwebsiteCreateAccount(
          response?.data?.response[0].websiteCreateAccount
        );
        setzapurl(response?.data?.response[0].zapurl);
        setAdminAddUserDocuSign(response?.data?.response[0].adminAddUserDocuSign);
        setShowModal(false);
      }
    } catch (error) {
      console.error("Error uploading image:", error);
      setShowModal(false);
    }
  };

  const fetchDefaultpasword = async () => {
    setShowModal(true);
    try {
      const response = await axios.get(
        `${APi_Url}api/admin/Show-Default-Password`,

        {
          headers: {
            Accept: "application/json",
            // "Content-Type": "application/json",
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        //  console.log("resposne list ", response?.data?.response);
        setDefaultPassword(response?.data?.response);
        setShowModal(false);
      }
    } catch (error) {
      console.error("Error uploading image:", error);
      setShowModal(false);
    }
  };
  useEffect(() => {
    getAllDocuSign();
    fetchDefaultpasword();
  }, []);

  const [defaultPasswordId, setDefaultPasswordId] = useState();
  const [defaultPasswordData, setDefaultPasswordData] = useState();

  const initialValues = {
    dpId: defaultPasswordId ? defaultPasswordId : "",
    password: defaultPasswordData?.password,
  };

  const validationSchema = Yup.object({
    password: Yup.string()
      .min(6, "Password must be at least 6 characters")
      .required("Password is Required"),
  });

  const onSubmit = async (values, { setSubmitting, resetForm }) => {
    const data = JSON.stringify(values);
    // console.log("data",data)
    try {
      const response = await axios.post(
        `${APi_Url}api/admin/Update-Default-Password`,
        data,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );

      console.log("resposne", response);

      toast.success("Successfully User Created");
      // showAccounts();
      setaccountModal(false);
      resetForm();
      fetchDefaultpasword();
    } catch (error) {
      console.error("Error ", error);
    } finally {
      setSubmitting(false); // Make sure to reset form state, if applicable
    }
  };

  const handleToggleChange = async (field, value) => {
    setShowModal(true);
    // console.log("values", value, "field", field);
    const updatedPayload = {
      docuSignControlId: docusignControlId,
      zapurl: field === "zapurl" ? value : zapurl,
      websiteCreateAccount:
        field === "websiteCreateAccount" ? value : websiteCreateAccount,
      adminAddUser: field === "adminAddUser" ? value : adminAddUser,
      createAccountDisplayOnWebsite:
        field === "createAccountDisplayOnWebsite"
          ? value
          : createAccountDisplayOnWebsite,
      note: "",
      adminAddUserDocuSign:field === "adminAddUserDocuSign"
      ? value
      : adminAddUserDocuSign,
      displayPriority: 0,
      isDeleted: false,
    };

    // Update the field state
    switch (field) {
      case "createAccountDisplayOnWebsite":
        setcreateAccountDisplayOnWebsite(value);
        break;
      case "adminAddUser":
        setadminAddUser(value);
        break;
      case "websiteCreateAccount":
        setwebsiteCreateAccount(value);
        break;
      case "zapurl":
        setzapurl(value);
        break;
        case "adminAddUserDocuSign":
          setAdminAddUserDocuSign(value);
          break;
        // adminAddUserDocuSign
      default:
        break;
    }

    try {
      // Call the API
      const response = await axios.post(
        `${APi_Url}api/account/update-docusign`,
        updatedPayload,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.data.statusCode == 200 && response.data.success) {
        toast.success("Settings updated successfully!");
        setShowModal(false);
        getAllDocuSign();
      }
      // console.log("API Response update:",);
    } catch (error) {
      toast.error("Failed to update settings!");
      setShowModal(false);
      console.error("API Error:", error);
    }
  };

  return (
    <>
      <section className="dashbordsect">
        <div className="defaultPasswordbox">
          <div className="passwordtext">
            <h2>Default Password - </h2> {defaultPassword.password}
          </div>
          <button
            className="add_accountbtn"
            onClick={() => {
              setaccountModal(true);
              setDefaultPasswordId(defaultPassword.dpId);
              setDefaultPasswordData(defaultPassword);
            }}
          >
            {" "}
            Update Password
          </button>
        </div>

        <div className="defaultPasswordbox" style={{maxWidth:"fit-content"}}>
          <div className="passwordtext">
            <h5>Enable User Registration on Frontend? </h5>
           
            <div className="form-check form-switch" style={{margin:0}}>
            <input
                        className="form-check-input"
                        checked={createAccountDisplayOnWebsite}
                        type="checkbox"
                        role="switch"
                        id="flexSwitchCheckDefault"
                        onChange={(e) =>
                          handleToggleChange("createAccountDisplayOnWebsite", e.target.checked)
                        }
                      />
                      </div>
            
          </div>
          <div className="passwordtext">
            <h5>Admin Can Add User From Admin Panel?</h5>
            
            <div className="form-check form-switch" style={{margin:0}}>
            <input
                        className="form-check-input"
                        checked={adminAddUser}
                        type="checkbox"
                        role="switch"
                        id="flexSwitchCheckDefault"
                        onChange={(e) =>
                          handleToggleChange("adminAddUser", e.target.checked)
                        }
                      />
                      </div>
          </div>
          <div className="passwordtext">
            <h5>Is Document Signing Needed for Frotnend Create Account?</h5>

            <div className="form-check form-switch" style={{margin:0}}>
            <input
                        className="form-check-input"
                        checked={websiteCreateAccount}
                        type="checkbox"
                        role="switch"
                        id="flexSwitchCheckDefault"
                        onChange={(e) =>
                          handleToggleChange("websiteCreateAccount", e.target.checked)
                        }
                      />
                      </div>
           
          </div>
          <div className="passwordtext">
            <h5>Is Document Signing Needed for Zap URL?</h5>
            <div className="form-check form-switch" style={{margin:0}}>
            <input
                        className="form-check-input"
                        
                        checked={zapurl}
                        type="checkbox"
                        role="switch"
                        id="flexSwitchCheckDefault"
                        onChange={(e) =>
                          handleToggleChange("zapurl", e.target.checked)
                        }
                      />
                      </div>

           
          </div>
          <div className="passwordtext">
            <h5>Is Document Signing Needed When Admin is adding users?</h5>
            <div className="form-check form-switch" style={{margin:0}}>
            <input
                        className="form-check-input"
                        
                        checked={adminAddUserDocuSign}
                        type="checkbox"
                        role="switch"
                        id="flexSwitchCheckDefault"
                        onChange={(e) =>
                          handleToggleChange("adminAddUserDocuSign", e.target.checked)
                        }
                      />
                      </div>

           
          </div>
        </div>

        {/* update password modal */}
        <div
          className={`modal fade inputmodal ${accountModal ? "show" : ""}`}
          aria-hidden="true"
          style={{ display: accountModal ? "block" : "none" }}
          tabIndex="-1"
          role="dialog"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h1>Update Password</h1>
              </div>
              <div className="modal-body">
                <Formik
                  initialValues={initialValues}
                  validationSchema={validationSchema}
                  onSubmit={onSubmit}
                  enableReinitialize={true}
                >
                  {({ isSubmitting, isValid, dirty, setFieldValue }) => (
                    <Form className="row needs-validation">
                      <div className="col-md-12">
                        <div className="row mb-3">
                          <label className="col-sm-5 col-form-label">
                            Default Password
                          </label>
                          <div className="col-sm-7">
                            <Field
                              type="text"
                              id="password"
                              name="password"
                              placeholder="Input here"
                              className="form-control"
                            />
                            <ErrorMessage
                              name="password"
                              component="div"
                              className="error_msg"
                            />
                          </div>
                        </div>
                      </div>

                      <div className="col-12">
                        <button className="btn kevlar_btn" type="submit">
                          Submit
                        </button>
                      </div>
                      <div className="col-12">
                        <button
                          className="btn kevlar_btn"
                          type="button"
                          onClick={() => {
                            setaccountModal(false);
                            setDefaultPasswordId();
                            setDefaultPasswordData();
                          }}
                        >
                          Cancel
                        </button>
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>
        {/* update password modal end */}
        <LoaderModal show={showModal} />
      </section>
    </>
  );
};

export default AdminSettings;
